module.exports = __webpack_public_path__ + "static/media/Defi-para-2.94b33bc8.jpg";